module.exports = __webpack_public_path__ + "static/burger-king-logo-4a3c0db3f07ec06cf2ec6d3aefb0c39b.png";